
export class PendingTaskDtoRequest {
  
  caseId: number;
  dueDate: Date;
}
